import { RDEqipEligibilityConservationACEP } from '@cibo/core'
import { conservationProgram } from '../ConservationPrograms'

export const ConservationACEP = conservationProgram<RDEqipEligibilityConservationACEP>(
  'acepEnrolled',
  'ACEP',
  'eqipEligibilityConservationACEP',
  '@cibo/landmanager/ConservationACEP'
)
